import { api } from '@/lib/api';
import type { HistoryImportChatSummary, HistoryImportRun } from '@troia-v3/types';

/** Resultado paginado de `GET /history-imports/runs/:id/chats` (backend não pagina por página/limit no payload — apenas items + total). */
export interface HistoryImportChatsResult {
  items: HistoryImportChatSummary[];
  total: number;
}

export const historyImportApi = {
  /**
   * Inicia uma sessão de importação de histórico para um canal (WhatsApp gateway).
   * Retorna a run recém-criada — status inicial normalmente `awaiting_qr`/`capturing`.
   */
  async startSession(channelId: string, periodDays: number): Promise<HistoryImportRun> {
    const response = await api.post('/history-imports/sessions', { channelId, periodDays });
    return response.data.data as HistoryImportRun;
  },

  /**
   * Busca o estado atual de uma run de importação (para polling).
   */
  async getRun(runId: string): Promise<HistoryImportRun> {
    const response = await api.get(`/history-imports/runs/${runId}`);
    return response.data.data as HistoryImportRun;
  },

  /**
   * Lista os chats capturados por uma run (paginado), disponível quando a run
   * chega em `ready_for_selection`.
   */
  async listChats(runId: string, page: number, search?: string): Promise<HistoryImportChatsResult> {
    const response = await api.get(`/history-imports/runs/${runId}/chats`, {
      params: { page, limit: 50, search },
    });
    return response.data.data as HistoryImportChatsResult;
  },

  /**
   * Dispara a ingestão dos chats selecionados no período informado.
   */
  async ingest(runId: string, chatIds: string[], periodStart: string, periodEnd: string): Promise<void> {
    await api.post(`/history-imports/runs/${runId}/ingest`, { chatIds, periodStart, periodEnd });
  },

  /**
   * Aborta uma run de importação em andamento.
   */
  async abort(runId: string): Promise<void> {
    await api.post(`/history-imports/runs/${runId}/abort`);
  },
};
